import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _capitalize from "lodash/capitalize";
import _get from "lodash/get";
import _find from "lodash/find";
var _excluded = ["text"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import { Text } from "../../Text/Text/Text";
import { TextPrice } from "../TextPrice/TextPrice";
import { Button } from "../../Button/Button/Button";
import { RadioInput } from "../../Input/RadioInput/RadioInput";
import styles from "./ChangePlan.module.scss";
import { MatchHeight } from "../../Utility/MatchHeight/MatchHeight";
import { MatchHeightElement } from "../../Utility/MatchHeight/MatchHeightElement";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ChangePlan = function ChangePlan(_ref) {
  var _ref$version = _ref.version,
    propVersion = _ref$version === void 0 ? 'modal' : _ref$version,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$headline = _ref.headline,
    headline = _ref$headline === void 0 ? '' : _ref$headline,
    _ref$headlineTypog = _ref.headlineTypog,
    headlineTypog = _ref$headlineTypog === void 0 ? 'headline3' : _ref$headlineTypog,
    _ref$defaultItemName = _ref.defaultItemName,
    defaultItemName = _ref$defaultItemName === void 0 ? '' : _ref$defaultItemName,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    changePlanCTA = _ref.changePlanCTA;
  var firstUpdate = useRef(true);
  var defaultItem = _find(items, function (item) {
    return item.name === defaultItemName;
  });
  var defaultItemValue = _get(defaultItem, 'value');
  var firstItemValue = _get(items, '[0].value');

  // The toggleV2 option is accepted only when there are exactly 2 plans.
  var version = propVersion === 'toggleV2' && (items === null || items === void 0 ? void 0 : items.length) !== 2 ? 'modal' : propVersion;

  // Set the default item or first item as selected.
  var _useState = useState(defaultItemValue || firstItemValue || ''),
    _useState2 = _slicedToArray(_useState, 2),
    option = _useState2[0],
    setOption = _useState2[1];

  // If data for the first item has changed (ex. plan changes dynamically),
  // Or the default value has changed.
  useEffect(function () {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    var newValue = defaultItemValue || '';
    if (!newValue) {
      newValue = firstItemValue;
    }
    setOption(newValue);
    if (onChange) {
      onChange(newValue);
    }
  }, [defaultItemName, defaultItemValue, firstItemValue, onChange, version]);
  var onPlanChange = function onPlanChange(option) {
    setOption(option);
    if (onChange) {
      onChange(option);
    }
  };
  var renderItem = function renderItem(item, index) {
    var _item$textPrice;
    if (!item) {
      return null;
    }
    return /*#__PURE__*/_jsx(RadioInput, {
      border: true,
      name: item.name || '',
      value: item.value || '',
      valueSelected: option,
      onChange: onPlanChange,
      label: item.label || '',
      labelTypog: item.labelTypog || 'headline4',
      labelClass: styles.label,
      wrapperClass: classnames(styles.radioinputWrapper, {
        [styles.radioinputWrapperSelected]: (item.value || '') === option
      }),
      circleClass: styles.circle,
      description: /*#__PURE__*/_jsxs(_Fragment, {
        children: [((_item$textPrice = item.textPrice) === null || _item$textPrice === void 0 ? void 0 : _item$textPrice.text) && /*#__PURE__*/_jsx(TextPrice, {
          text: item.textPrice.text,
          price: item.textPrice.price || '',
          typog: item.textPrice.typog || 'subhead2',
          typogPriceText: item.textPrice.typogPriceText || 'subhead2',
          priceClass: classnames(styles.price, item.textPrice.priceClass),
          className: classnames(styles.content, styles.text, item.textPrice.className)
        }), item.description && /*#__PURE__*/_jsx(Text, {
          className: classnames(styles.content, styles.description),
          typog: "bodycopy",
          richText: true,
          children: item.description
        })]
      })
    }, "change-plan-".concat(index));
  };
  var renderSwitcher = function renderSwitcher() {
    if (!items || items.length < 2) {
      return null;
    }
    if (!items[0].switcherLabel || !items[1].switcherLabel) {
      return null;
    }
    return /*#__PURE__*/_jsx("div", {
      className: styles["planSwitcher".concat(_capitalize(version))],
      children: /*#__PURE__*/_jsx(MatchHeight, {
        children: [0, 1].map(function (index) {
          var item = items[index];
          var isSelected = option === item.value;
          return /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
            type: "no-style",
            className: classnames(styles["btnSwitcher".concat(_capitalize(version))], {
              [styles.active]: isSelected
            }),
            onClick: function onClick() {
              return onPlanChange(item.value || '');
            },
            selected: isSelected,
            accessibilityLabel: item.switcherLabel
          }, item.switcherAttributes), {}, {
            children: /*#__PURE__*/_jsx(MatchHeightElement, {
              group: "change-plan",
              children: /*#__PURE__*/_jsx(Text, {
                typog: "subhead3",
                className: styles.switcherLabel,
                children: item.switcherLabel
              })
            })
          }), index);
        })
      })
    });
  };
  switch (version) {
    case 'switcher':
    case 'toggle':
      {
        var selectedItem = items.find(function (item) {
          return option === item.value;
        });
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [renderSwitcher(), (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.label) && /*#__PURE__*/_jsx(Text, {
            typog: "headline3",
            className: styles.switcherSelectedPlanLabel,
            children: selectedItem.label
          }), (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.description) && /*#__PURE__*/_jsx(Text, {
            typog: "headline6",
            className: styles.switcherSelectedPlanDescription,
            richText: true,
            children: selectedItem.description
          })]
        });
      }
    case 'toggleV2':
      {
        // Component is only used when there are exactly 2 items.
        var otherItemIdx = items.findIndex(function (item) {
          return option === item.value;
        }) === 0 ? 1 : 0;
        var otherItem = items[otherItemIdx];
        var _ref2 = changePlanCTA || {},
          text = _ref2.text,
          otherProps = _objectWithoutProperties(_ref2, _excluded);
        var buttonText = text === null || text === void 0 ? void 0 : text.replace('!planName', (otherItem === null || otherItem === void 0 ? void 0 : otherItem.label) || '');
        return /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
          type: "link",
          onClick: function onClick() {
            return onPlanChange(otherItem.value || '');
          },
          className: styles.change
        }, otherProps), {}, {
          children: buttonText
        }));
      }
    case 'modal':
    default:
      {
        return /*#__PURE__*/_jsxs("div", {
          className: className,
          children: [headline && /*#__PURE__*/_jsx(Text, {
            className: styles.headline,
            typog: headlineTypog,
            children: headline
          }), /*#__PURE__*/_jsx("div", {
            className: styles.wrapper,
            children: items === null || items === void 0 ? void 0 : items.map(function (item, index) {
              return renderItem(item, index);
            })
          })]
        });
      }
  }
};